import { keyframes } from 'styled-components';

export default /*#__PURE__*/ keyframes`
  0% {
    transform: scale(0);
  }

  95% {
    transform: scale(1.05);
  }

  98% {
    transform: scale(0.98);
  }

  100% {
    transform: scale(1);
  }
`;
